import { render } from "./MatrixHolder.vue?vue&type=template&id=4c3778ca&scoped=true"
import script from "./MatrixHolder.vue?vue&type=script&lang=js"
export * from "./MatrixHolder.vue?vue&type=script&lang=js"

import "./MatrixHolder.vue?vue&type=style&index=0&id=4c3778ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c3778ca"]])

export default __exports__